// import React, { useEffect, useState } from 'react';

// import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
// import classes from './TelephoneDirectory.module.scss';
// import { empDir } from '../../API/API';

// const TelephoneDirectory = () => {
//     const userID = localStorage.getItem('userID');
//     const data = JSON.parse(localStorage.getItem('data'));
//     const [dir,setDir] = useState([]);
    
//     useEffect(()=>{
//         empDir(userID, data.empid, data.token)
//         .then((response) => {
//             setDir(response.data);
//         })
//         .catch((e) => {});       
//         ;
//     },[]);
    
//     const [searchTerm, setSearchTerm] = useState('');
//     const debounce = (func, delay) => {
//       let timeoutId;
//       return (...args) => {
//         clearTimeout(timeoutId);
//         timeoutId = setTimeout(() => {
//           func.apply(this, args);
//         }, delay);
//       };
//     }
//     const handleSearchChange = (event) => {
//         setSearchTerm(event.target.value.toLowerCase());
//     };
//     const debounceSearchChange = debounce(handleSearchChange,300);
    
//     const filteredData = dir.filter((person) => {
//         if(!person.intercom) person.intercom='';
//         if(!person.mobile) person.mobile='';
//         if(!person.email) person.email='';
//         const searchString = person.empname.toLowerCase() + person.desig.toLowerCase() + person.intercom.toLowerCase() + person.mobile.toLowerCase();
//         return searchString.includes(searchTerm.toLowerCase());
//     });
//     return (
//         <>
//             <BreadCrumb name="Telephone Directory" />
//             <div className={classes.Container}>
//                 <div className={classes.BodyDiv}>
//                     <input autoFocus type="text" placeholder='Search' style={{width:"100%"}} onChange={debounceSearchChange}/>
//                     { filteredData.length ? <>
//                         <table width='100%'>
//                         <tbody> 
//                         {filteredData.map((item, index) => { 
//                             return (
//                                 <tr key={index}>
//                                 <td>
//                                 { (!item.email && !item.intercom && !item.mobile) ? <></>
//                                 :
//                                 <>
//                                 <a href={window.env.APP_URL+"/genqr.php"+
//                                         "?name="+encodeURIComponent(item.empname)+
//                                         "&mobile="+encodeURIComponent(item.mobile)+
//                                         "&email="+encodeURIComponent(item.emp_email)+
//                                         "&name="+encodeURIComponent(item.empname)+
//                                         "&empid="+encodeURIComponent(item.empid)+
//                                         "&desig="+encodeURIComponent(item.desig)
//                                         }>
//                                     <button style={{float:"right",width:"15dvw"}}>
//                                         <img src={require("../../assets/icons/add-contact.svg").default} alt="Get" width={24} />
//                                     </button>
//                                 </a>
//                                 <h3>{item.empname}, {item.desig}</h3>
//                                 ID: {item.empid}<br />
//                                 Location: {item.present}<br />
//                                 Email: {item.emp_email}<br />
//                                 Intercom: {item.intercom}<br />
//                                 Mobile: {item.mobile}<br />
//                                 { item.mobile && <a href={"tel:"+item.mobile}><button style={{float:"right"}}>Call {item.empname}</button></a> }
//                                 </> 
//                                 }
//                                 </td>
//                                 </tr>
//                             );
//                         })}
//                         </tbody>
//                         </table>
//                     </>: 
//                         <h2 style={{width:"100%", textAlign:"center"}}>Loading...<br />Please try changing your search criteria in case of no results</h2>    
//                     }
//                 </div>
//             </div>
//         </>
//     )
// }

// export default TelephoneDirectory









import React, { useEffect, useState, useCallback } from 'react';
import BreadCrumb from '../../utilities/BreadCrumb/BreadCrumb';
import classes from './TelephoneDirectory.module.scss';
import { empDir } from '../../API/API';

const TelephoneDirectory = () => {
    const userID = localStorage.getItem('userID');
    const data = JSON.parse(localStorage.getItem('data'));
    const [dir, setDir] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');

    useEffect(() => {
        empDir(userID, data.empid, data.token)
            .then((response) => {
                setDir(response.data);
            })
            .catch((e) => {
                console.error('Error fetching directory:', e);
            });
    }, [userID, data.empid, data.token]);

    const debounce = (func, delay) => {
        let timeoutId;
        return (...args) => {
            clearTimeout(timeoutId);
            timeoutId = setTimeout(() => {
                func.apply(this, args);
            }, delay);
        };
    };

    const handleSearchChange = useCallback((event) => {
        setSearchTerm(event.target.value.toLowerCase());
    }, []);

    const debounceSearchChange = useCallback(debounce(handleSearchChange, 300), [handleSearchChange]);

    const filteredData = dir.filter((person) => {
        const empname = person.empname || '';
        const desig = person.desig || '';
        const intercom = person.intercom || '';
        const mobile = person.mobile || '';
        const email = person.emp_email || '';
        const searchString = empname.toLowerCase() + desig.toLowerCase() + intercom.toLowerCase() + mobile.toLowerCase();
        return searchString.includes(searchTerm);
    });

    return (
        <>
            <BreadCrumb name="Telephone Directory" />
            <div className={classes.Container}>
                <div className={classes.BodyDiv}>
                    <input 
                        autoFocus 
                        type="text" 
                        placeholder='Search' 
                        style={{ width: "100%" }} 
                        onChange={debounceSearchChange} 
                    />
                    {filteredData.length ? (
                        <table width='100%'>
                            <tbody>
                                {filteredData.map((item, index) => (
                                    <tr key={index}>
                                        <td>
                                            {(!item.email && !item.intercom && !item.mobile) ? null : (
                                                <>
                                                    <a href={`${window.env.APP_URL}/genqr.php?name=${encodeURIComponent(item.empname)}&mobile=${encodeURIComponent(item.mobile)}&email=${encodeURIComponent(item.emp_email)}&name=${encodeURIComponent(item.empname)}&empid=${encodeURIComponent(item.empid)}&desig=${encodeURIComponent(item.desig)}`}>
                                                        <button style={{ float: "right", width: "15dvw" }}>
                                                            <img src={require("../../assets/icons/add-contact.svg").default} alt="Get" width={24} />
                                                        </button>
                                                    </a>
                                                    <h3>{item.empname}, {item.desig}</h3>
                                                    ID: {item.empid}<br />
                                                    Location: {item.present}<br />
                                                    Email: {item.emp_email}<br />
                                                    Intercom: {item.intercom}<br />
                                                    Mobile: {item.mobile}<br />
                                                    {item.mobile && <a href={`tel:${item.mobile}`}><button style={{ float: "right" }}>Call {item.empname}</button></a>}
                                                </>
                                            )}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    ) : (
                        <h2 style={{ width: "100%", textAlign: "center" }}>Loading...<br />Please try changing your search criteria in case of no results</h2>
                    )}
                </div>
            </div>
        </>
    );
};

export default TelephoneDirectory;
